

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import yoga from "../assets/yoga4.jpg";
// import axios from "axios";
// import { BASE_URL } from "../Config";

// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";

// function Login({ setUser }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const navigate = useNavigate();

//   useEffect(() => {
//     const onResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const isMobile = screenWidth < 768;

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(`${BASE_URL}/auth/login`, { email, password });

//       const token = res.data.token;
//       const loggedUser = res.data.data;

//       if (!token) {
//         setErrorMessage("Invalid login response. Try again!");
//         setErrorPopup(true);
//         return;
//       }

//       // ✅ FIXED: Only sessionStorage — clears automatically on tab/browser close
//       // ❌ REMOVED: localStorage — was causing user to stay logged in after logout + refresh
//       sessionStorage.setItem("token", token);
//       sessionStorage.setItem("user", JSON.stringify(loggedUser));

//       setUser(loggedUser);
//       setSuccessPopup(true);

//       setTimeout(() => {
//         setSuccessPopup(false);
//         if (loggedUser.role === "admin") {
//           navigate("/dashboard");
//         } else {
//           navigate("/user-rules");
//         }
//       }, 1200);
//     } catch (err) {
//       const msg =
//         err.response?.data?.message || "Login failed! Please check your credentials.";
//       setErrorMessage(msg);
//       setErrorPopup(true);
//     }
//   };

//   return (
//     <motion.div
//       style={{
//         ...styles.page,
//         paddingTop: isMobile ? "80px" : "120px",
//         padding: isMobile ? "80px 10px 20px" : "120px 20px 20px",
//       }}
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//     >
//       <motion.div
//         style={{
//           ...styles.card,
//           width: isMobile ? "100%" : "900px",
//           maxWidth: "900px",
//           height: isMobile ? "auto" : "480px",
//           flexDirection: isMobile ? "column" : "row",
//         }}
//         initial={{ y: 50, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 80, damping: 15 }}
//       >
//         {/* LEFT IMAGE */}
//         <motion.div
//           style={{
//             ...styles.left,
//             width: isMobile ? "100%" : "50%",
//             borderRight: isMobile ? "none" : "1px solid #f0f0f0",
//           }}
//         >
//           <motion.img
//             src={yoga}
//             alt="yoga"
//             style={{ ...styles.img, width: isMobile ? "100%" : "80%" }}
//             whileHover={{ scale: 1.05 }}
//           />
//         </motion.div>

//         {/* RIGHT FORM */}
//         <motion.div
//           style={{
//             ...styles.right,
//             width: isMobile ? "100%" : "50%",
//             padding: isMobile ? "25px" : "50px",
//           }}
//         >
//           <h2 style={styles.title}>Yoga Login</h2>
//           <p style={styles.subtitle}>Make sure your account is secure</p>

//           <form onSubmit={handleLogin} style={styles.form}>
//             <input
//               type="email"
//               placeholder="Type your Email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//               required
//             />
//             <input
//               type="password"
//               placeholder="Type your Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//               required
//             />
//             <div style={styles.linkRow}>
//               <Link to="/forgot-password" style={styles.link}>Forgot Password?</Link>
//               <Link to="/register" style={styles.link}>Register</Link>
//             </div>
//             <motion.button
//               type="submit"
//               style={styles.button}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               LOGIN
//             </motion.button>
//           </form>
//         </motion.div>
//       </motion.div>

//       <SuccessPopup open={successPopup} onClose={() => setSuccessPopup(false)} message="Login Successful!" />
//       <ErrorPopup open={errorPopup} onClose={() => setErrorPopup(false)} message={errorMessage} />
//     </motion.div>
//   );
// }

// const styles = {
//   page: {
//     backgroundColor: "#62bf6bff",
//     minHeight: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "flex-start",
//   },
//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "15px",
//     display: "flex",
//     boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
//     overflow: "hidden",
//   },
//   left: { display: "flex", justifyContent: "center", alignItems: "center" },
//   img: { height: "auto" },
//   right: { display: "flex", flexDirection: "column", alignItems: "center" },
//   title: { fontSize: "24px", fontWeight: "600", color: "#333" },
//   subtitle: { fontSize: "14px", color: "#777", marginBottom: "25px" },
//   form: { width: "100%", display: "flex", flexDirection: "column", gap: "15px" },
//   input: { padding: "12px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "15px" },
//   linkRow: { display: "flex", justifyContent: "space-between" },
//   link: { textDecoration: "none", color: "#333", fontWeight: "500" },
//   button: {
//     backgroundColor: "#62bf6bff",
//     borderRadius: "30px",
//     padding: "12px",
//     border: "none",
//     fontWeight: "bold",
//     fontSize: "16px",
//     cursor: "pointer",
//   },
// };

// export default Login;

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { BASE_URL } from "../Config";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import BG_IMAGE from "../assets/bg.png";

// Inject global keyframes + responsive styles once
if (typeof document !== "undefined" && !document.getElementById("yoga-kf")) {
  const s = document.createElement("style");
  s.id = "yoga-kf";
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=Inter:wght@400;500;600;700&display=swap');
    @keyframes floatLeaf { 0%{transform:translateY(0) rotate(0deg);} 100%{transform:translateY(-16px) rotate(14deg);} }
    @keyframes spin { to{transform:rotate(360deg);} }
    .yoga-inp-wrap:focus-within { border-color:#2da44e !important; background:#f2fbf4 !important; }

    .yoga-page {
      min-height: 100vh;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-attachment: fixed;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 24px 80px;
      position: relative;
      font-family: 'Inter','Segoe UI',sans-serif;
      box-sizing: border-box;
    }
    .yoga-card {
      position: relative;
      z-index: 1;
      background: rgba(255,255,255,0.97);
      backdrop-filter: blur(18px);
      border-radius: 24px;
      width: 420px;
      padding: 44px 40px 36px;
      box-shadow: 0 24px 80px rgba(0,0,0,0.18), 0 4px 20px rgba(0,0,0,0.08);
    }

    @media (max-width: 768px) {
      .yoga-page {
        justify-content: center;
        padding: 20px 16px;
        background-position: top center;
        background-attachment: scroll;
        align-items: flex-start;
        padding-top: 40px;
      }
      .yoga-card {
        width: 100%;
        max-width: 420px;
        padding: 32px 24px 28px;
        border-radius: 20px;
      }
      .yoga-leaf { display: none; }
    }

    @media (max-width: 390px) {
      .yoga-card {
        padding: 28px 18px 24px;
        border-radius: 16px;
      }
    }
  `;
  document.head.appendChild(s);
}

const LotusIcon = ({ size = 20, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22c0-4.4-3.6-8-8-8 0 4.4 3.6 8 8 8z"/>
    <path d="M12 22c0-4.4 3.6-8 8-8-4.4 0-8 3.6-8 8z"/>
    <path d="M12 12C12 7.6 8.4 4 4 4c0 4.4 3.6 8 8 8z"/>
    <path d="M12 12C12 7.6 15.6 4 20 4c-4.4 0-8 3.6-8 8z"/>
    <path d="M12 12v10"/>
  </svg>
);
const MailIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="3"/><path d="M2 7l10 7 10-7"/>
  </svg>
);
const LockIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="11" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>
  </svg>
);
const EyeOffIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);
const EyeOnIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export default function Login({ setUser }) {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup]     = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/auth/login`, { email, password });
      const token      = res.data.token;
      const loggedUser = res.data.data;
      if (!token) {
        setErrorMessage("Invalid login response. Try again!");
        setErrorPopup(true);
        setLoading(false);
        return;
      }
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("user", JSON.stringify(loggedUser));
      setUser(loggedUser);
      setSuccessPopup(true);
      setTimeout(() => {
        setSuccessPopup(false);
        navigate(loggedUser.role === "admin" ? "/dashboard" : "/user-rules");
      }, 1200);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || "Login failed! Please check your credentials.");
      setErrorPopup(true);
    }
    setLoading(false);
  };

  const leaves = [
    { top:"4%",   left:"3%",   size:26, delay:"0s"   },
    { top:"7%",   left:"16%",  size:18, delay:"0.9s" },
    { bottom:"8%",left:"5%",   size:22, delay:"0.5s" },
    { top:"15%",  left:"38%",  size:16, delay:"1.3s" },
    { bottom:"12%",left:"30%", size:14, delay:"0.7s" },
    { top:"3%",   right:"48%", size:20, delay:"0.3s" },
  ];

  return (
    <div
  className="yoga-page"
  style={{
    backgroundImage: `url(${BG_IMAGE})`,   // ← inline, not in CSS class
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
  }}
>
      {/* Floating leaves — hidden on mobile via CSS class */}
      {leaves.map((l, i) => (
        <span
          key={i}
          className="yoga-leaf"
          style={{
            position: "fixed", zIndex: 0, pointerEvents: "none",
            userSelect: "none", fontSize: l.size,
            top: l.top, left: l.left, right: l.right, bottom: l.bottom,
            animation: `floatLeaf 6s ease-in-out infinite alternate`,
            animationDelay: l.delay,
          }}
        >🍃</span>
      ))}

      <motion.div
        className="yoga-card"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      >
        {/* Mandala watermark */}
        <svg style={S.mandala} viewBox="0 0 130 130" aria-hidden="true">
          <g transform="translate(65,65)">
            {Array.from({ length: 12 }, (_, i) => (
              <ellipse key={i} cx="0" cy="-38" rx="6" ry="18" fill="#2da44e" transform={`rotate(${i * 30})`}/>
            ))}
            <circle cx="0" cy="0" r="16" fill="none" stroke="#2da44e" strokeWidth="2"/>
            <circle cx="0" cy="0" r="7" fill="#2da44e"/>
          </g>
        </svg>

        {/* Logo */}
        <div style={S.logoRow}>
          <div style={S.logoIcon}><LotusIcon size={20} color="#fff"/></div>
          <span style={S.logoText}>YogaRefer.Com</span>
        </div>

        <h1 style={S.title}>Sign in to <span style={S.green}>YogaRefer</span></h1>
        <div style={S.divRow}>
          <span style={S.divLine}/><LotusIcon size={17} color="#2da44e"/><span style={S.divLine}/>
        </div>
        <p style={S.subtitle}>Enter your credentials to access your account</p>

        <form onSubmit={handleLogin} style={S.form}>
          {/* Email */}
          <div className="yoga-inp-wrap" style={S.inpWrap}>
            <span style={S.inpIcon}><MailIcon/></span>
            <input
              type="email" placeholder="Email address"
              value={email} onChange={e => setEmail(e.target.value)}
              style={S.input} required
            />
          </div>

          {/* Password */}
          <div className="yoga-inp-wrap" style={S.inpWrap}>
            <span style={S.inpIcon}><LockIcon/></span>
            <input
              type={showPass ? "text" : "password"} placeholder="Password"
              value={password} onChange={e => setPassword(e.target.value)}
              style={{ ...S.input, paddingRight: "44px" }} required
            />
            <button type="button" onClick={() => setShowPass(!showPass)} style={S.eyeBtn} aria-label="Toggle password">
              {showPass ? <EyeOnIcon/> : <EyeOffIcon/>}
            </button>
          </div>

          {/* Remember / Forgot */}
          <div style={S.rowBetween}>
            <label style={S.checkLabel}>
              <input
                type="checkbox" checked={remember}
                onChange={e => setRemember(e.target.checked)}
                style={S.checkbox}
              />
              <span style={S.checkText}>Remember me</span>
            </label>
            <Link to="/forgot-password" style={S.forgotLink}>Forgot password?</Link>
          </div>

          {/* Login button */}
          <motion.button
            type="submit" disabled={loading} style={S.loginBtn}
            whileHover={{ scale: 1.025 }} whileTap={{ scale: 0.97 }}
          >
            {loading
              ? <span style={S.spinner}/>
              : <><LotusIcon size={18} color="#fff"/><span style={{ marginLeft: 7 }}>Login</span></>
            }
          </motion.button>
        </form>

        <p style={S.regRow}>
          Don't have an account?{" "}
          <Link to="/register" style={S.createLink}>Create one</Link>
        </p>
      </motion.div>

      <SuccessPopup open={successPopup} onClose={() => setSuccessPopup(false)} message="Login Successful!"/>
      <ErrorPopup   open={errorPopup}   onClose={() => setErrorPopup(false)}   message={errorMessage}
        title={/banned/i.test(errorMessage) ? "Account banned" : undefined}/>
    </div>
  );
}

const S = {
  mandala: {
    position: "absolute", top: -18, right: -18,
    width: 130, height: 130, opacity: 0.07, pointerEvents: "none",
  },
  logoRow:  { display: "flex", alignItems: "center", gap: 10, marginBottom: 22 },
  logoIcon: {
    width: 38, height: 38, borderRadius: "50%",
    background: "linear-gradient(135deg,#3aab5a,#1f8a3b)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 3px 10px rgba(45,164,78,0.35)",
    flexShrink: 0,
  },
  logoText: { fontSize: 13, fontWeight: 700, color: "#1a3a24" },
  title: {
    fontFamily: "'Playfair Display',serif",
    fontSize: "clamp(20px, 5vw, 26px)",
    fontWeight: 800, color: "#111",
    textAlign: "center", marginBottom: 6,
  },
  green:    { color: "#2da44e" },
  divRow:   { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, margin: "10px 0 8px" },
  divLine:  { flex: 1, maxWidth: 52, height: 1.5, background: "#2da44e", borderRadius: 2 },
  subtitle: { fontSize: 13, color: "#999", marginBottom: 22, textAlign: "center" },
  form:     { display: "flex", flexDirection: "column", gap: 14 },
  inpWrap:  {
    position: "relative", display: "flex", alignItems: "center",
    border: "1.5px solid #e4e4e4", borderRadius: 12, background: "#fafafa",
    transition: "border-color 0.2s,background 0.2s",
  },
  inpIcon:  {
    position: "absolute", left: 14, color: "#b0c8b4",
    display: "flex", alignItems: "center", pointerEvents: "none",
  },
  input: {
    flex: 1, border: "none", outline: "none", background: "transparent",
    padding: "14px 14px 14px 44px", fontSize: 15, color: "#333",
    fontFamily: "'Inter',sans-serif",
    // Prevent iOS zoom on focus (font-size must be >= 16px on Safari)
    WebkitAppearance: "none",
  },
  eyeBtn: {
    position: "absolute", right: 12, background: "none", border: "none",
    cursor: "pointer", color: "#c0c0c0", display: "flex", alignItems: "center",
    padding: 8, // larger touch target on mobile
  },
  rowBetween: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", flexWrap: "wrap", gap: 8,
  },
  checkLabel: { display: "flex", alignItems: "center", gap: 7, cursor: "pointer" },
  checkbox:   { width: 16, height: 16, accentColor: "#2da44e", cursor: "pointer" },
  checkText:  { fontSize: 13, color: "#555" },
  forgotLink: { textDecoration: "none", color: "#2da44e", fontSize: 13, fontWeight: 600 },
  loginBtn: {
    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
    background: "linear-gradient(135deg,#3aab5a 0%,#2da44e 70%,#1a8c3c 100%)",
    color: "#fff", border: "none", borderRadius: 50,
    padding: "15px 20px", fontSize: 15, fontWeight: 700, cursor: "pointer",
    boxShadow: "0 6px 22px rgba(45,164,78,0.45)", marginTop: 4,
    minHeight: 52, // good tap target
  },
  spinner: {
    width: 20, height: 20,
    border: "2.5px solid rgba(255,255,255,0.35)",
    borderTopColor: "#fff", borderRadius: "50%",
    animation: "spin 0.7s linear infinite", display: "inline-block",
  },
  regRow:     { textAlign: "center", fontSize: 13, color: "#888", marginTop: 16 },
  createLink: { color: "#2da44e", fontWeight: 700, textDecoration: "none" },
};